<!-- Modals -->
<app-deprecated-modal-form
    #surveyDetailsModal
    [form]="surveyDetailsForm"
    (save)="onSave()"
    (cancel)="onCancel()"
    *ngIf="isAdmin || isCreator"
    headerText="surveys.show.surveyDetailsModal.headerText"
>
    <app-form-survey-details #surveyDetailsForm [survey]="survey"></app-form-survey-details>
</app-deprecated-modal-form>

<app-deprecated-confirmation-dialog
    #confirmDelete
    description="surveys.show.deleteModal.description"
    label="surveys.show.deleteModal.label"
    [negative]="true"
>
</app-deprecated-confirmation-dialog>

<app-common-bulk-select-survey-participants-dialog
    *ngIf="isAdmin || isCreator"
    #surveyParticipantsSelection
    [label]="'surveys.show.surveyParticipantsSelection.label'"
></app-common-bulk-select-survey-participants-dialog>

<app-survey-display
    #surveyDisplayComponent
    *ngIf="survey?.userAssignment"
    [survey]="survey"
    [fields]="survey.userAssignment.jsonData"
    [response]="survey.userResponse"
    [performanceReviewImprovements]="hasPerformanceReviewImprovementsFeatureFlag"
    (saved)="onResponseSave($event)"
></app-survey-display>

<!-- Body -->
<div class="ui narrow segment basic" [class.loading]="isLoading">
    <app-header
        [title]="survey.title"
        [back]="true"
        [backRoute]="backRoute"
        [contextMenu]="isAdmin || isCreator"
        contextMenuType="material"
    >
        <button mat-menu-item (click)="showEdit()">{{ 'surveys.show.contextMenu.editLabel' | translate }}</button>
        <button mat-menu-item *ngIf="survey.isComplete" (click)="onExport()">
            {{ 'surveys.show.contextMenu.exportLabel' | translate }}
        </button>
        <button mat-menu-item *ngIf="!survey.isComplete" (click)="remind()">
            {{ 'surveys.show.contextMenu.remindLabel' | translate }}
        </button>
        <button mat-menu-item *ngIf="!survey.isComplete" (click)="forceComplete()">
            {{ 'surveys.show.contextMenu.forceCompleteLabel' | translate }}
        </button>
        <button mat-menu-item (click)="onDelete()">{{ 'surveys.show.contextMenu.deleteLabel' | translate }}</button>
    </app-header>

    <div class="ui segment">
        <div class="surveyStatus">
            <ng-container *ngIf="survey.statusId === Status.Completed">
                <span class="ui tiny circular empty green label"></span>
                {{ 'surveys.surveyStatuses.completed' | translate }}
            </ng-container>
            <ng-container *ngIf="survey.statusId === Status.InProgress">
                <span class="ui tiny circular empty yellow label"></span>
                {{ 'surveys.surveyStatuses.inProgress' | translate }}
            </ng-container>
            <ng-container *ngIf="survey.statusId === Status.Missed">
                <span class="ui tiny circular empty orange label"></span>
                {{ 'surveys.surveyStatuses.missed' | translate }}
            </ng-container>
            <ng-container *ngIf="survey.statusId === Status.Overdue">
                <span class="ui tiny circular empty red label"></span>
                {{ 'surveys.surveyStatuses.overdue' | translate }}
            </ng-container>
        </div>
        <app-segment-header title="surveys.show.surveyDetailsTitle"></app-segment-header>
        <form class="ui static form" #form="ngForm">
            <div class="inline field">
                <label> {{ 'surveys.show.dueDateLabel' | translate }} </label>
                {{ survey.dueAt | appDate: 'mediumDate' }}
            </div>

            <div *ngIf="survey.reoccuring !== 'never'" class="inline field">
                <label> {{ 'surveys.show.recurringLabel' | translate }} </label>
                {{ survey.reoccuring }}
            </div>

            <div class="inline field">
                <label>{{ 'surveys.show.templateLabel' | translate }}</label>
                {{ survey.template?.name }}
            </div>

            <div class="inline field">
                <label>{{ 'surveys.show.anonymousLabel' | translate }}</label>
                {{ survey.isAnonymous | yesNo }}
            </div>

            <div class="inline field">
                <label>{{ 'surveys.show.submissionsLabel' | translate }}</label>
                {{
                    'surveys.show.submissionsDetail'
                        | translate
                            : { submissionsCount: survey.submissionsCount, assignmentsCount: survey.assignmentsCount }
                }}
            </div>

            <div class="field">
                <label>{{ 'surveys.show.descriptionLabel' | translate }}</label>
                <p [innerHTML]="survey?.description | nl2br | sanitizeHtml" style="margin-bottom: 0px"></p>
            </div>

            <ui-button
                [disabled]="survey.isComplete"
                type="primary"
                *ngIf="survey?.userAssignment && !survey?.userResponse?.submittedAt && !survey.isComplete"
                (click)="launch()"
                style="display: block; width: 150px; margin: 0 auto"
            >
                {{ 'surveys.show.completeSurveyLabel' | translate }}
            </ui-button>

            <ui-button
                (click)="results()"
                type="primary"
                style="display: block; width: 150px; margin: 0 auto"
                *ngIf="survey.isComplete && (isAdmin || isCreator)"
            >
                {{ 'surveys.show.viewResultsLabel' | translate }}</ui-button
            >
        </form>
    </div>

    <div class="ui table segment" *ngIf="!survey.isAnonymous && (isAdmin || isCreator)">
        <app-segment-header
            *ngIf="survey.statusId !== Status.Completed"
            title="surveys.show.participantsTitle"
            (edit)="onAssign()"
        ></app-segment-header>

        <app-segment-header
            *ngIf="survey.statusId === Status.Completed"
            title="surveys.show.participantsTitle"
        ></app-segment-header>

        <table *ngIf="survey.assignments?.length" class="ui unstackable table">
            <tbody>
                <tr *ngFor="let assignment of survey.assignments">
                    <td class="collapsing">
                        <app-avatar *ngIf="assignment.employee" [employee]="assignment.employee"></app-avatar>
                    </td>
                    <td>{{ assignment?.employee?.firstName }} {{ assignment?.employee?.lastName }}</td>
                    <td class="right aligned">
                        <ng-container *ngIf="assignment.response?.submittedAt">
                            <span class="ui tiny circular empty green label"></span>
                            {{ 'surveys.surveyStatuses.completed' | translate }}
                        </ng-container>
                        <ng-container *ngIf="!assignment.response?.submittedAt">
                            <span class="ui tiny circular empty yellow label"></span>
                            {{ 'surveys.surveyStatuses.inProgress' | translate }}
                        </ng-container>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>

    <div class="ui table segment">
        <app-segment-header title="surveys.show.createdByTitle"></app-segment-header>
        <table *ngIf="survey.creator" class="ui unstackable table">
            <tbody>
                <tr>
                    <td class="collapsing">
                        <app-avatar *ngIf="survey.creator" [employee]="survey.creator"></app-avatar>
                    </td>
                    <td>{{ survey?.creator?.firstName }} {{ survey?.creator?.lastName }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
